export default function getImageUrl(image) {
    return process.env.PUBLIC_URL + `/${image || 'default.png'}`
}
